import { render } from "./ApprovalsListCardHistoryApprovalsCardStatus.vue?vue&type=template&id=1897f73c"
import script from "./ApprovalsListCardHistoryApprovalsCardStatus.vue?vue&type=script&lang=js"
export * from "./ApprovalsListCardHistoryApprovalsCardStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__